export const alertStyles = {
  root: {
    py: 0.25,
    borderRadius: 4,
    '& .MuiAlert-icon': {
      marginTop: 0.5,
      marginRight: 1,
      padding: 0,
    },
  },
};
